<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      :farms="farms"
      :factories="factories"
      :trucks="trucks"
      :operators="operators"
    />
    <div v-show="!loading">
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :data="harvests"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ACTION - DROPDOWN -->
            <vs-dropdown
              v-show="false"
              vs-trigger-click
              class="dd-actions cursor-pointer mr-4 mb-4"
            >
              <div
                class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full"
              >
                <span class="mr-2">Actions</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>

              <vs-dropdown-menu>
                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Delete</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon
                      icon="ArchiveIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Archive</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon
                      icon="FileIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Print</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon
                      icon="SaveIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>Another Action</span>
                  </span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

            <!-- ADD NEW -->
            <div
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="addNewData"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>

            <!-- <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="generateRandom"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Generate Data</span>
          </div> -->

            <!-- generateRandom -->
          </div>

          <!-- ITEMS PER PAGE -->
          <vs-dropdown
            vs-trigger-click
            class="cursor-pointer mb-4 mr-4 items-per-page-handler"
          >
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  harvests.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : harvests.length
                }}
                of {{ queriedItems }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="a">Farm</vs-th>
          <vs-th sort-key="b">Factory</vs-th>
          <vs-th sort-key="c">Truck</vs-th>
          <vs-th sort-key="d">m3</vs-th>
          <vs-th sort-key="h">Operator</vs-th>
          <vs-th sort-key="e">Authorized by</vs-th>
          <vs-th sort-key="f">Date</vs-th>
          <!-- <vs-th>Action</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="font-medium truncate">
                  <router-link :to="`/farms/${tr.a._id}`">{{
                    tr.a.a
                  }}</router-link>
                </p>
              </vs-td>

              <vs-td>
                <p class="font-medium truncate">{{ tr.b.a }}</p>
              </vs-td>

              <vs-td>
                <p class="font-medium truncate">{{ tr.c.a }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.c.b }}</p>
              </vs-td>

              <vs-td>
                <p class="font-medium truncate">
                  {{ tr.h ? ("a" in tr.h ? tr.h.a : "Operator N/A") : "N/A" }}
                </p>
              </vs-td>

              <vs-td>
                <p class="font-medium truncate">
                  {{ tr.e.b }}
                </p>
              </vs-td>

              <vs-td>
                <p class="font-medium truncate">
                  {{ parseDate(tr.f) }}
                </p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <!-- <feather-icon
                  icon="ChevronRightIcon"
                  svgClasses="w-8 h-5 hover:text-primary stroke-current"
                  @click.stop="viewHarvest(tr._id)"
                /> -->
                <!-- <feather-icon
                  icon="EditIcon"
                  svgClasses="w-8 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  v-show="false"
                  icon="TrashIcon"
                  svgClasses="w-8 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="deleteData(tr.id)"
                /> -->
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>

    <div v-show="loading">
      <div class="flex flex-wrap justify-between">
        <skeleton-box class="mt-2" height="40px" width="180px"></skeleton-box>
        <skeleton-box class="mt-2" height="40px" width="300px"></skeleton-box>
      </div>
      <skeleton-box class="mt-8" height="35px"></skeleton-box>
      <skeleton-box class="mt-6" height="35px"></skeleton-box>
      <skeleton-box class="mt-6" height="35px"></skeleton-box>
      <skeleton-box class="mt-6" height="35px"></skeleton-box>
      <skeleton-box class="mt-6" height="35px"></skeleton-box>
      <skeleton-box class="mt-6" height="35px"></skeleton-box>
      <skeleton-box class="mt-6" height="35px"></skeleton-box>
      <skeleton-box class="mt-6" height="35px"></skeleton-box>
    </div>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import SkeletonBox from "@/components/SkeletonBox.vue";

import p from "@/db/pouch";

export default {
  components: {
    DataViewSidebar,
    SkeletonBox,
  },
  data() {
    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      harvests: [],
      farms: [],
      trucks: [],
      factories: [],
      operators: [],
      loading: true,
    };
  },
  pouch: {
    harvestData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 9 },
      };
    },
    farmData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 6 },
      };
    },
    factoryData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 5 },
      };
    },
    truckData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 2 },
      };
    },
    operatorData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 3 },
      };
    },
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.harvests.length;
    },
  },
  watch: {
    harvestData(v) {
      this.decrypt("harvests", v);
    },
    farmData(v) {
      this.decrypt("farms", v);
    },
    factoryData(v) {
      this.decrypt("factories", v);
    },
    truckData(v) {
      this.decrypt("trucks", v);
    },
    operatorData(v) {
      this.decrypt("operators", v);
    },
  },
  methods: {
    parseDate(d) {
      return this.$moment(d).format("dddd, MMMM Do YYYY HH:mm a");
    },
    async decrypt(k, v) {
      this.loading = true;
      this[k] = await p.de(v);
      this.loading = false;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    viewHarvest(id) {
      this.$router.push({
        name: "view-harvest",
        params: {
          id: id,
        },
      });
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
